import { Vector2 } from "three";
import { WaveForm } from "../../../../../library-js/audio/visualization/wave-form/WaveForm";
import { WaveFormRenderer } from "../../../../../library-js/audio/visualization/wave-form/WaveFormRenderer";
import { HSLColor } from "../../../../../library-js/colors/HSLColor";
import { DOMHitTest } from "../../../../../library-js/dom-tools/DOMHitTest";
import { ElementContainer } from "../../../../../library-js/dom-tools/ElementContainer";
import { ElementType } from "../../../../../library-js/dom-tools/ElementType";
import { Events, OnDrag } from "../../../../../library-js/dom-tools/EventListeners";
import { DragData } from "../../../../../library-js/dom-ui/basics/DragData";
import { CanvasDrawer } from "../../../../../library-js/dom/CanvasDrawer";
import { AudioEditorUIComponent } from "./AudioEditorUIComponent";

export class WaveformView extends AudioEditorUIComponent<HTMLCanvasElement>
{
  _renderer:WaveFormRenderer;

  setWaveForms( waveforms:WaveForm[])
  {
    this._renderer = new WaveFormRenderer( this.element, waveforms[ 0 ] );
    this._renderer.renderWave();
  }

  async initialize():Promise<void>
  {
    this._createElement( ElementType.canvas );

    let canvas = this.element;
    canvas.width = 1920;
    canvas.height = 256;

    let renderer = new CanvasDrawer( canvas );
    renderer.fillBackground( new HSLColor( 0, 0, 10 ) );

    this.ui.appendChild( this );

    this._addListeners();

    return Promise.resolve();
  }

  protected _addListeners()
  {
    let startData:DragData<number>;
    let lastMoved:DragData<number>;
    let dragging = false;

    OnDrag.add( this.element,
      ( e )=>
      {
        if ( ! this._renderer )
        {
          return;
        }

        let mouseEvent = Events.toMouseEvent( e );
        
        
        if ( ! mouseEvent )
        {
          return;
        }

        
        let data = DragData.create( e, null );

        if ( Events.isStart( e ) )
        {
          dragging = mouseEvent.button === Events.MouseButtonMiddle || 
                    ( mouseEvent.button === Events.MouseButtonLeft && ( e.ctrlKey || e.shiftKey ) );

          if ( ! dragging )
          {
            return;
          }

          startData = data;

          let center = DOMHitTest.getNormalizedPosition( startData.position.clone(), this.element );
          startData.value = this._renderer.getDataPositionAtNormalizedX( center.x );
          lastMoved = startData;         
          
        }

        if ( ! dragging )
        {
          return;
        }

        if ( Events.isMove( e ) )
        {
          let movement = data.position.clone().sub( lastMoved.position );
          
          if ( e.ctrlKey )
          {
            movement.y = 0;
          }

          if ( e.shiftKey )
          {
            movement.x = 0;
          }

          let canvas = this.element;
          this._renderer.changeView( movement, startData.value, new Vector2( canvas.width, canvas.height ), 70 );
        }

        lastMoved = data;

        

      } 
    );
  }
  
}